import type { HelpFile } from '../../types/help'
import { IdentityGrantsDetailTestIds } from '../../../testids/IdentityGrantsDetailTestIds'

export const identityGrantsDetailHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [IdentityGrantsDetailTestIds.identityGrantsDetailPage]: 'Effektive Zugriffsrechte einer einzelnen Identität — alle Operationen, die die Identität auf jeder Ressource ausführen kann, mit den beitragenden Quellzuweisungen.',
    [IdentityGrantsDetailTestIds.btnRecalculate]: 'Effektive Berechtigung dieser Identität neu berechnen, nachdem Zugriffsänderungen noch nicht neu berechnet wurden.',
    [IdentityGrantsDetailTestIds.cardTitleActiveGrants]: null,
    [IdentityGrantsDetailTestIds.cardTitleEffectiveAccessGrants]: 'Detaillierte Liste jeder effektiven Berechtigung: Ressource, Operation, Umgebung und die beitragenden Quellzuweisungen.',
    [IdentityGrantsDetailTestIds.cardTitleLastCalculated]: null,
    [IdentityGrantsDetailTestIds.cardTitleTotalGrants]: null,
    [IdentityGrantsDetailTestIds.colEnforcementObject]: 'Enforcement-Objekt — das systemspezifische Element (Gruppe, Rolle, ACL-Eintrag), das den Zugriff gewährt.',
    [IdentityGrantsDetailTestIds.colEnvironment]: 'Umgebung, in der der Zugriff gilt, z. B. Produktion oder Test.',
    [IdentityGrantsDetailTestIds.colExpand]: null,
    [IdentityGrantsDetailTestIds.colOperation]: 'Durch diese Berechtigung erlaubte Operation, z. B. Lesen, Schreiben oder Löschen.',
    [IdentityGrantsDetailTestIds.colResource]: null,
    [IdentityGrantsDetailTestIds.colSourceAccessProfile]: 'Zugriffsprofil, das diese Berechtigung geliefert hat.',
    [IdentityGrantsDetailTestIds.colSourceAssignmentExpires]: 'Ablaufzeitpunkt der Quellzuweisung, die diese Berechtigung lieferte.',
    [IdentityGrantsDetailTestIds.colSourceAssignmentStart]: 'Zeitpunkt, ab dem die Quellzuweisung wirksam wurde.',
    [IdentityGrantsDetailTestIds.colSourceCreatedAt]: 'Zeitpunkt der Erstellung der Quellzuweisung.',
    [IdentityGrantsDetailTestIds.colStatus]: 'Status der Berechtigung, z. B. aktiv oder abgelaufen.',
    [IdentityGrantsDetailTestIds.colTargetSystem]: null,
    [IdentityGrantsDetailTestIds.colValidFrom]: null,
    [IdentityGrantsDetailTestIds.colValidTo]: null,
    [IdentityGrantsDetailTestIds.filterEnvironment]: null,
    [IdentityGrantsDetailTestIds.filterSystem]: null,
    [IdentityGrantsDetailTestIds.linkIdentityDetails]: null,
  },
}
